import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { LoginService } from '../../../services/login';
import { ToastrService } from 'ngx-toastr';
import { LocalStorage } from '../../../services/local-storage';
import { AppKitService } from '../../../services/appkitservice';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.html',
  styleUrls: ['./header.css'],
})
export class Header {

  isSidebarOpen: boolean = true;
  showModal: boolean = false;
  walletAddress: string | null = null;

  constructor(private router: Router,
    private loginApi: LoginService,
    private toastr: ToastrService,
    private localStorage: LocalStorage,
    public appKitService: AppKitService,
    private cdr: ChangeDetectorRef // 2. Inject ChangeDetectorRef
  ) { }

  async ngOnInit() {
    await this.appKitService.waitForInitialization();
    await this.appKitService.reconnectWallet();

    // 3. Sync the address initially
    this.syncAddress();

    // 4. (Optional but recommended) Listen for account changes
    // If your AppKitService has an observable or watch function, use it here.
    // Otherwise, we refresh after the connect action.
  }

  async connectWallet() {
    await this.appKitService.connectWallet();
    this.syncAddress(); // 5. Update local variable after connection
  }
  private syncAddress() {
    const addr = this.appKitService.getAddress();
    // console.log('Current Address found:', addr); // Check your browser console for this!

    this.walletAddress = addr;

    // This is the most important line for third-party wallet libraries
    this.cdr.detectChanges();
  }

  /** Toggle sidebar open/close */
  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  /** Open logout confirmation modal */
  openLogoutModal(): void {
    this.showModal = true;
  }

  logout() {
    this.loginApi.logout({}).subscribe({
      next: (res: any) => {
        console.log("Logout success:", res);
        this.toastr.success("Logged out successfully.");
        // Clear local storage
        this.localStorage.clear();

        // Redirect to login
        this.router.navigate(['/login']);
      },
      error: (err: any) => {
        console.error("Logout failed:", err);
        this.toastr.error("Logout failed. Please try again.");
        // Still redirect user
        localStorage.removeItem('token');
        this.router.navigate(['/login']);
      }
    });
  }
}
